<div id="footer">
    <div class="container-fluid pt-5 pb-3 px-md-3 px-lg-5">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-xl-3">
               <div class="address  d-flex ">
                <div class="icon me-3">
                    <i class="fa-solid fa-location-dot"></i>
                </div>
                <p class="mb-1">Maharana Pratap Public School <br>Kurukshetra, <br>(Haryana) 136118</p>
               </div>
               <div class="address  d-flex ">
                <div class="icon me-3">
                    <i class="fa-solid fa-eye"></i>
                </div>
                <p>No. of Visitors: {{count}}</p>
               </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                <div class="phone d-flex">
                    <div class="icon me-3">
                        <i class="fa-solid fa-phone"></i>
                    </div>
                    <a  href="tel:8059700244">8059700244</a>
                </div>
                <div class="mail d-flex mt-2">
                    <div class="icon me-3 ">
                        <i class="fa-solid fa-at"></i>
                    </div>
                    <a href="mailto:maharanapratapschool@yahoo.co.in">maharanapratapschool@yahoo.co.in</a> 
                </div>
                <div class="mail d-flex mt-2">
                    <div class="icon me-3 ">
                        <i class="fa-solid fa-globe"></i>
                    </div>
                    <a  href="https://mppskkr.com" target="_blank">mppskkr.com</a>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-xl-4 d-flex">
                <div class="watch me-3">
                    <img src="/assets/json/clock.gif" alt="">
                </div>
                 <div class="data">
                    <p class="mb-0">School Timings</p>
                    <p class="mb-0">Monday - Saturday 09:20 AM - 02:45 PM</p>
                    <p >{{today | date:'fullDate'}}</p>
                 </div>
              </div>
              <div class="col-xl-2 d-none d-xl-block">
               <app-map></app-map>
                
            </div>
        </div>
        <hr class="opacity-100 bg-white">

        <div class="row footer-menu">
            <div class="col-6 col-sm-4 col-lg-2">
                <h3>Accomplishment</h3>
                <ul class="ps-0">
                    <li>
                        <a routerLink="/accomplishment/co">Co Scholastic</a>
                    </li>
                    <li>
                        <a routerLink="/accomplishment/games">Games & Sports</a>
                    </li>
                    <li>
                        <a routerLink="/accomplishment/cultural">Cultural</a>
                    </li>
                </ul>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
                <h3>Quick Links</h3>
                <ul class="ps-0">
                    <li>
                        <a routerLink="/contact-us">Contact Us</a>
                    </li>
                    <li>
                        <a routerLink="/privacy-policy">Privacy Policy</a>
                    </li>
                    <li>
                        <a routerLink="/refund-policy">Refund Policy</a>
                    </li>
                    <!-- <li>
                        <a routerLink="/faculty/workshop">Workshop</a>
                    </li> -->
                </ul>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
                <h3>Campus</h3>
                <ul class="ps-0">
                    <li>
                        <a routerLink="/campus/administrative">Administrative Block</a>
                    </li>
                    <li>
                        <a routerLink="/campus/academic">Academic Block</a>
                    </li>
                    <li>
                        <a routerLink="/campus/music">Music & Art</a>
                    </li>
                    <li>
                        <a routerLink="/campus/labs">Laboratories</a>
                    </li>
                    <li>
                        <a routerLink="/campus/ground">Ground</a>
                    </li>
                    <li>
                        <a routerLink="/campus/transport">Transport</a>
                    </li>
                    <li>
                        <a routerLink="/campus/infrastructure">Infrastructure Type</a>
                    </li>
                </ul>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
                <h3>Achievements</h3>
                <ul class="ps-0">
                    <li>
                        <a routerLink="/achievements/cbse">CBSE Result</a>
                    </li>
                    <li>
                        <a routerLink="/achievements/exemplary">Exemplary Performances</a>
                    </li>
                    <li>
                        <a routerLink="/achievements/awards">Awards & Scholarships</a>
                    </li>
                </ul>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
                <h3>Glimpses</h3>
                <ul class="ps-0">
                    <li>
                        <a routerLink="/glimpses/magazine">School Magazine</a>
                    </li>
                    <li>
                        <a routerLink="/gallery">Gallery</a>
                    </li>
                </ul>
                
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
                <h3>Admissions</h3>
                <ul class="ps-0">
                    <li>
                        <a routerLink="/admission/process">Admission Procedure</a>
                    </li>
                    <li>
                        <a routerLink="/admission/entrance-syllabus">Entrance Test Syllabus</a>
                    </li>
                    <li>
                        <a routerLink="/admission/library">Library & eBooks</a>
                    </li>
                    <li>
                        <a routerLink="/admission/hours">School Hour </a>
                    </li>
                    <li>
                        <a routerLink="/admission/houses">School Houses</a>
                    </li>
                    <li>
                        <a routerLink="/admission/uniform">School Uniform</a>
                    </li>
                </ul>
            </div>
        </div>
        <hr class="opacity-100 bg-white">
        <div class="row">
            <div class="col-12 col-sm-6">
                <a href="https://okiedokiepay.com" target="_blank">Crafted with ❤️ by Okie Dokie <br>
                    Haryana's No. 1 Campus Automation Partner</a>
            </div>
            <div class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end mt-3 mt-sm-0">
                <div class="icon social me-3">
                    <a href="https://www.facebook.com/profile.php?id=100063570684714" target="_blank"><i class="fa-brands fa-facebook align-bottom"></i></a>
                    
                </div>
                <div class="icon social me-3">
                   <a href="https://www.instagram.com/maharanapratapschoolsec7/?igshid=ZmVmZTY5ZGE%3D" target="_blank"><i class="fa-brands fa-instagram align-bottom"  style="background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); border-radius: 10px;"></i></a>
                </div>
                <div class="icon social me-3">
                   <a href="https://www.youtube.com/@mppsbillboard9392/featured" target="_blank"><i class="fa-brands fa-youtube align-bottom" style="color: #FF0000;background:#fff;border-radius: 100%;"></i></a>
                </div>
                <div class="icon social me-3">
                   <a href=""><i class="fa-brands fa-whatsapp align-bottom" style="color: #fff;background:#25D366;border-radius: 100%;"></i></a>
                </div>
                <div class="icon social me-1 bg-white">
                   <a href=""><i class="fa-brands fa-linkedin-in align-bottom" style="color: #0A66C2;"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>